import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Settings page redirects to Profile page
// Profile page contains all settings in the correct mobile-friendly dark theme format
export default function Settings() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to profile page which has all settings
    navigate('/profile', { replace: true });
  }, [navigate]);

  return null;
}
